import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../lib/auth';
import { canAccessPath, getDefaultPathForRole, normalizeRole } from '../../lib/permissions';

/** Shared access gate for the staff portal and the full-screen simulator. */
export function RequireStaff({ children }: { children: ReactNode }) {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated || !user || !normalizeRole(user.role)) {
    return <Navigate to="/login" state={{ returnTo: location.pathname }} replace />;
  }

  if (user.mustChangePassword) {
    return <Navigate to="/change-password" replace />;
  }

  if (!canAccessPath(user.role, location.pathname)) {
    return <Navigate to={getDefaultPathForRole(user.role)} replace />;
  }

  return children;
}
